"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificateIssueStatusLookup = void 0;
const enums_1 = require("../contracts/enums");
exports.CertificateIssueStatusLookup = {
    shares: {
        enable: {
            subtype: enums_1.ActivitySubType.ACTIVATE_SHARE_CERTIFICATES,
            description: "Share certificates activated.",
        },
        disable: {
            subtype: enums_1.ActivitySubType.DEACTIVATE_SHARE_CERTIFICATES,
            description: "Share certificates deactivated.",
        },
    },
    notes: {
        enable: {
            subtype: enums_1.ActivitySubType.ACTIVATE_NOTE_CERTIFICATES,
            description: "Note certificates activated.",
        },
        disable: { subtype: enums_1.ActivitySubType.DEACTIVATE_NOTE_CERTIFICATES, description: "Note certificates deactivated." },
    },
};
//# sourceMappingURL=certificateLookup.js.map